// Modules
import React from "react"; 
import moment from "moment";

// Interfaces
import { ManagementCompany } from "Interfaces/AYPResultInterface";
import { Tip } from "Interfaces/TipInterface";

// Components
import ToolTip from 'Generic/ToolTip';
import { Position } from '../ToolTip';

// Styles
import "./MvReservationTypeToolTip.sass";

// @ts-ignore
import { LocalizationContext } from 'react-localize';
import MvIcon from "Generic/MvIcon";

type Props = {
    resID: number;
    managementCompany: ManagementCompany;
    position?: Position;
};

class MvReservationTypeToolTip extends React.Component<Props, {}> {   
    constructor(props:Props) {
        super(props);
    }

    render() {

        const { localize } = this.context;
        const { name, phone, url } = this.props.managementCompany;

        // Management Company Name
        const mcName = <>
            <p className="company-name">{name}</p>
        </>

        // Management Company Phone
        //TODO: add icon and need to figure out link (if it is a link and what it does)
        const mcPhone = <>
            <div className="company-contact-container">
            <MvIcon
                color="#5F5F5F"
                style={{
                  height: "14px",
                  width: "14px"
                }}
                icon="phone"
            />
            <a href={`tel:${phone}`} className="company-contact-info">{phone}</a>
            </div>
        </>
        let friendlyPhoneURL = phone;

        // some links don't have the http or https
        if (phone.indexOf('http://') === -1 && phone.indexOf('https://') === -1) {
            friendlyPhoneURL = 'https://' + friendlyPhoneURL;          
        }
        const mcPhoneUrl = <>
            <div className="company-contact-container">
                <MvIcon
                    color="#5F5F5F"
                    style={{
                    height: "14px",
                    width: "14px"
                    }}
                    icon="phone"
                />
                <a href={`${friendlyPhoneURL}`} target="_blank" className="company-contact-info">{phone}</a>
            </div>
        </>

        // Management Company Email
        //TODO: add icon and need to figure out link (if it is a link and what it does)
        let friendlyURL = url;

        // some links don't have the http or https
        if (url.indexOf('http://') === -1 && url.indexOf('https://') === -1) {
            friendlyURL = 'https://' + friendlyURL;          
        }

        const mcWebsite = <>
            <div className="company-contact-container">
            <MvIcon
                color="#5F5F5F"
                style={{
                  height: "14px",
                  width: "14px"
                }}
                icon="link"
            />
            <a href={friendlyURL} className="company-contact-info" target="_blank" >{url}</a>
            </div>
        </>

        let view = [];
        view.push(mcName);
        if (phone != "" && !phone.includes('www.'))
            view.push(mcPhone);
        if (phone != "" && phone.includes('www.'))
            view.push(mcPhoneUrl);
        if (url != "" || phone.includes('www.'))
            view.push(mcWebsite);

        // add the view to the Tip jsx
        const tooltip: [Tip] = [{
            label: "",
            desc: "",
            jsx: view
        }]

        return (
            <div className="tool-tip-res-type">
                <ToolTip useRefToPosition={false} id={`mv-res-type-tooltip-${this.props.resID}`} tabIndex={-1} tip={tooltip} position={this.props.position}>
                    {this.props.children}
                </ToolTip>
            </div>
        )
    }
}

MvReservationTypeToolTip.contextType = LocalizationContext;
export default MvReservationTypeToolTip